module.exports = __webpack_public_path__ + "img/icon-confirmation.8d4504ed.svg";